import { gql } from '__generated__'

export const GetCandidateMergePreview = gql(/* GraphQL */ `
    query GetCandidateMergePreview($id: ID!) {
        candidate(id: $id) {
            id
            user {
                firstName
                lastName
            }
            bio {
                bio
            }
            compensation {
                compensation
            }
            employmentType {
                id
                value
            }
            gender {
                id
                gender {
                    value
                }
            }
            higModelTest {
                id
                higModelTest {
                    value
                }
            }
            higReferral {
                id
                higReferral {
                    value
                }
            }
            hometown {
                id
                city
            }
            interviewBucket {
                id
                bucket
            }
            lgbtq {
                id
                lgbtq {
                    value
                }
            }
            outreachStatus {
                id
                status
            }
            personalityScores {
                id
                ccatPercentile
            }
            recruitingStatus {
                id
                status
            }
            startDate {
                id
                value
            }
            systemStatus {
                id
                status
            }
            testScores {
                id
                satTotal
                actScore
                gmatScore
                greTotalScore
            }
            tier {
                id
                tier {
                    value
                }
            }
            otherAnalysts {
                id
                analyst
            }
            citizenships {
                id
                citizenship {
                    value
                }
            }
            cpiPlaced {
                id
                cpiPlaced {
                    value
                }
            }
            dealSourcingRoles {
                id
                dealSourcingRole {
                    value
                }
            }
            ethnicities {
                id
                ethnicity {
                    value
                }
            }
            languages {
                id
                language {
                    value
                }
            }
            mbaTiers {
                id
                mbaTier {
                    value
                }
            }
            personalityAttributes {
                id
                personalityAttribute {
                    value
                }
            }
            programs {
                id
                value
            }
            realEstateDealExperiences {
                id
                realEstateDealExperience {
                    value
                }
            }
            revenueExperiences {
                id
                revenueExperience {
                    value
                }
            }
            staffers {
                id
                staffer {
                    firstName
                    lastName
                }
            }
            veteranStatuses {
                id
                veteranStatus {
                    value
                }
            }
            visaStatuses {
                id
                visaStatus {
                    value
                }
            }
            industryPreferences {
                id
                order
                preferenceIndustry {
                    value
                }
            }
            sectorPreferences {
                id
                order
                preferenceSector {
                    value
                }
            }
            locationPreferences {
                id
                order
                preferenceLocation {
                    value
                }
            }
            companyPreferences {
                id
                order
                preferenceCompany {
                    value
                }
                customValue
            }
            documents {
                id
                documentKey
                createdAt
            }
            education {
                id
                graduationDate
                college {
                    value
                }
            }
            candidateNotes {
                id
                notePreview
                createdAt
            }
            candidateGroupNotes {
                id
                groupNoteId
            }
            references {
                id
                firstName
                lastName
            }
            workExperience {
                id
                startDate
                endDate
                isCurrent
                title {
                    value
                }
                company {
                    value
                }
            }
            referenceAttribute {
                id
                referenceAttribute {
                    value
                }
            }
            rosters {
                id
                roster {
                    rosterName
                }
            }
            jobBoardsResponses {
                id
                jobBoard {
                    name
                }
                isInterested
            }
            higTeams {
                id
                higTeam {
                    value
                }
            }
            schedules {
                id
                eventUrl
            }
            eppScores {
                id
                score
                eppCategory {
                    value
                }
            }
            companyClientContacts {
                id
                group
                contactType
            }
            rosterClientContacts {
                id
                rosterId
            }
        }
    }
`)

export const MergeCandidates = gql(/* GraphQL */ `
    mutation MergeCandidates($winnerId: ID!, $loserId: ID!, $liveRun: Boolean) {
        mergeCandidates(
            winnerId: $winnerId
            loserId: $loserId
            liveRun: $liveRun
        ) {
            name
            bio {
                bio
            }
            compensation {
                compensation
            }
            employmentType {
                id
                value
            }
            gender {
                id
                gender {
                    value
                }
            }
            higModelTest {
                id
                higModelTest {
                    value
                }
            }
            higReferral {
                id
                higReferral {
                    value
                }
            }
            hometown {
                id
                city
            }
            interviewBucket {
                id
                bucket
            }
            lgbtq {
                id
                lgbtq {
                    value
                }
            }
            outreachStatus {
                id
                status
            }
            personalityScores {
                id
                ccatPercentile
            }
            recruitingStatus {
                id
                status
            }
            startDates {
                id
                value
            }
            systemStatus {
                id
                status
            }
            testScores {
                id
                satTotal
                actScore
                gmatScore
                greTotalScore
            }
            tier {
                id
                tier {
                    value
                }
            }
            analysts {
                id
                analyst
            }
            citizenships {
                id
                citizenship {
                    value
                }
            }
            cpiPlaced {
                id
                cpiPlaced {
                    value
                }
            }
            dealSourcingRoles {
                id
                dealSourcingRole {
                    value
                }
            }
            ethnicities {
                id
                ethnicity {
                    value
                }
            }
            languages {
                id
                language {
                    value
                }
            }
            mbaTiers {
                id
                mbaTier {
                    value
                }
            }
            personalityAttributes {
                id
                personalityAttribute {
                    value
                }
            }
            programs {
                id
                value
            }
            realEstateDealExperiences {
                id
                realEstateDealExperience {
                    value
                }
            }
            revenueExperiences {
                id
                revenueExperience {
                    value
                }
            }
            staffers {
                id
                staffer {
                    firstName
                    lastName
                }
            }
            veteranStatuses {
                id
                veteranStatus {
                    value
                }
            }
            visaStatuses {
                id
                visaStatus {
                    value
                }
            }
            industryPreferences {
                id
                order
                preferenceIndustry {
                    value
                }
            }
            sectorPreferences {
                id
                order
                preferenceSector {
                    value
                }
            }
            locationPreferences {
                id
                order
                preferenceLocation {
                    value
                }
            }
            companyPreferences {
                id
                order
                preferenceCompany {
                    value
                }
                customValue
            }
            documents {
                id
                documentKey
                createdAt
            }
            education {
                id
                graduationDate
                college {
                    value
                }
            }
            candidateNotes {
                id
                notePreview
                createdAt
            }
            candidateGroupNotes {
                id
                groupNoteId
            }
            references {
                id
                firstName
                lastName
            }
            workExperience {
                id
                startDate
                endDate
                isCurrent
                title {
                    value
                }
                company {
                    value
                }
            }
            referenceAttribute {
                id
                referenceAttribute {
                    value
                }
            }
            rosters {
                id
                roster {
                    rosterName
                }
            }
            jobBoardsResponses {
                id
                jobBoard {
                    name
                }
                isInterested
            }
            higTeams {
                id
                higTeam {
                    value
                }
            }
            schedules {
                id
                eventUrl
            }
            eppScores {
                id
                score
                eppCategory {
                    value
                }
            }
            companyClientContacts {
                id
                group
                contactType
            }
            rosterClientContacts {
                id
                rosterId
            }
        }
    }
`)
